import React from 'react';
import SEO from '@/components/seo/SEO';
import HeroSection from '@/components/home/sections/HeroSection';
import PersonaSection from '@/components/home/sections/PersonaSection';
import FunnelDemoSection from '@/components/home/sections/FunnelDemoSection';
import RoiCalculatorSection from '@/components/home/sections/RoiCalculatorSection';
import SellerStoriesSection from '@/components/home/sections/SellerStoriesSection';
import ProofSection from '@/components/home/sections/ProofSection';
import LeadMagnetSection from '@/components/home/sections/LeadMagnetSection';
import CtaSection from '@/components/home/sections/CtaSection';
import MobileStickyCta from '@/components/home/sections/MobileStickyCta';
import { HOME_FAQS } from '@/lib/homeData';
import ResourcesLinksSection from '@/components/home/sections/ResourcesLinksSection';

const HomePage: React.FC = () => {
  const appBaseUrl = import.meta.env.VITE_APP_URL || '';
  const appSignUpUrl = appBaseUrl ? `${appBaseUrl}/auth?mode=signup` : '/auth?mode=signup';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'SoftwareApplication',
        name: 'LendLifted',
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web',
        description:
          'LendLifted is financing-enabled checkout software for high-ticket service businesses. Create quote links, share QR checkout, and optimize conversion with buyer-intent insights.',
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'USD',
          description: 'Start free with usage-based checkout workflow',
        },
      },
      {
        '@type': 'FAQPage',
        mainEntity: HOME_FAQS.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.a,
          },
        })),
      },
    ],
  };

  return (
    <div className="overflow-x-hidden bg-[#f8f5ef] pb-24 text-slate-900 md:pb-0">
      <SEO
        title="LendLifted | Seller Financing Software for High-Ticket Service Businesses"
        description="Convert more quotes with financing-enabled checkout links, QR payments, and buyer-intent follow-up insights. Built for contractors, studios, and custom-service teams."
        canonical="/"
        jsonLd={jsonLd}
      />

      <HeroSection appSignUpUrl={appSignUpUrl} />
      <PersonaSection />
      <FunnelDemoSection />
      <div id="roi-calculator" className="scroll-mt-24">
        <RoiCalculatorSection />
      </div>
      <SellerStoriesSection />
      <ProofSection />
      <LeadMagnetSection />
      <CtaSection appSignUpUrl={appSignUpUrl} />
      <ResourcesLinksSection />
      <MobileStickyCta appSignUpUrl={appSignUpUrl} />
    </div>
  );
};

export default HomePage;
